/* index.tsx generated by @compiled/babel-plugin v0.36.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { useQuery } from '@apollo/client';
import PrinterIcon from '@atlaskit/icon/core/printer';
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle, ModalTransition } from '@atlaskit/modal-dialog';
import { graphQLRequest } from '@atlassian/mpac-fetch-wrapper';
import { DateUtils } from '@atlassian/mpac-utils';
import { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { Button } from '../../Buttons/Button';
import { BodyNormal } from '../../Typography';
import { UserGeneratedHTML } from '../../UserGeneratedHTML';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const _5 = "._slp31hna{word-wrap:break-word}";
const _4 = "._18m91wug{overflow-y:auto}";
const _3 = "._c71ltye8{max-height:20rem}";
const _2 = "._2lx21bp4{flex-direction:column}";
const _ = "._1e0c1txw{display:flex}";
var AppSoftwareVersionListingByKey = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "AppSoftwareVersionListingByKey" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "appKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, directives: [] }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "buildNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } }, directives: [] }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketplaceStore" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "appSoftwareVersionListingByAppKey" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "appKey" }, value: { kind: "Variable", name: { kind: "Name", value: "appKey" } } }, { kind: "Argument", name: { kind: "Name", value: "buildNumber" }, value: { kind: "Variable", name: { kind: "Name", value: "buildNumber" } } }], directives: [{ kind: "Directive", name: { kind: "Name", value: "optIn" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "to" }, value: { kind: "StringValue", value: "MarketplaceStoreAppSoftwareVersionListingByAppKey", block: false } }] }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "vendorLinks" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "eula" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "bonTermsSupported" }, arguments: [], directives: [] }, { kind: "Field", name: { kind: "Name", value: "partnerSpecificTerms" }, arguments: [], directives: [] }] } }] } }] } }] } }], loc: { start: 0, end: 359, source: { body: "query AppSoftwareVersionListingByKey($appKey: String!, $buildNumber: ID!) {\n  marketplaceStore {\n    appSoftwareVersionListingByAppKey(appKey: $appKey, buildNumber: $buildNumber)\n      @optIn(to: \"MarketplaceStoreAppSoftwareVersionListingByAppKey\") {\n      vendorLinks {\n        eula\n        bonTermsSupported\n        partnerSpecificTerms\n      }\n    }\n  }\n}\n", name: "GraphQL request", locationOffset: { line: 1, column: 1 } } } };
export const BONTERMS_STANDARD_AGREEMENT_URL = 'https://www.atlassian.com/licensing/marketplace/end-user-agreement-v1';
export const getEmceeAppVersionListing = async options => {
  var _data$marketplaceStor, _data$marketplaceStor2, _data$marketplaceStor3, _data$marketplaceStor4, _data$marketplaceStor5, _data$marketplaceStor6, _data$marketplaceStor7, _data$marketplaceStor8, _data$marketplaceStor9;
  const {
    appKey,
    buildNumber,
    gatewayUrl
  } = options;
  const {
    data,
    errors
  } = await graphQLRequest(gatewayUrl, {
    variables: {
      appKey,
      buildNumber: buildNumber !== null && buildNumber !== void 0 ? buildNumber : ''
    },
    skip: !appKey || !buildNumber,
    query: AppSoftwareVersionListingByKey
  });
  const vendorLinks = {
    eula: data === null || data === void 0 ? void 0 : (_data$marketplaceStor = data.marketplaceStore) === null || _data$marketplaceStor === void 0 ? void 0 : (_data$marketplaceStor2 = _data$marketplaceStor.appSoftwareVersionListingByAppKey) === null || _data$marketplaceStor2 === void 0 ? void 0 : (_data$marketplaceStor3 = _data$marketplaceStor2.vendorLinks) === null || _data$marketplaceStor3 === void 0 ? void 0 : _data$marketplaceStor3.eula,
    bonTermsSupported: data === null || data === void 0 ? void 0 : (_data$marketplaceStor4 = data.marketplaceStore) === null || _data$marketplaceStor4 === void 0 ? void 0 : (_data$marketplaceStor5 = _data$marketplaceStor4.appSoftwareVersionListingByAppKey) === null || _data$marketplaceStor5 === void 0 ? void 0 : (_data$marketplaceStor6 = _data$marketplaceStor5.vendorLinks) === null || _data$marketplaceStor6 === void 0 ? void 0 : _data$marketplaceStor6.bonTermsSupported,
    partnerSpecificTerms: data === null || data === void 0 ? void 0 : (_data$marketplaceStor7 = data.marketplaceStore) === null || _data$marketplaceStor7 === void 0 ? void 0 : (_data$marketplaceStor8 = _data$marketplaceStor7.appSoftwareVersionListingByAppKey) === null || _data$marketplaceStor8 === void 0 ? void 0 : (_data$marketplaceStor9 = _data$marketplaceStor8.vendorLinks) === null || _data$marketplaceStor9 === void 0 ? void 0 : _data$marketplaceStor9.partnerSpecificTerms
  };
  return {
    vendorLinks,
    data,
    error: errors
  };
};
export function useAppVersionListing(options) {
  var _data$marketplaceStor10, _data$marketplaceStor11, _data$marketplaceStor12, _data$marketplaceStor13, _data$marketplaceStor14, _data$marketplaceStor15, _data$marketplaceStor16, _data$marketplaceStor17, _data$marketplaceStor18;
  const {
    appKey,
    buildNumber,
    skip
  } = options;
  const {
    data,
    error,
    loading
  } = useQuery(AppSoftwareVersionListingByKey, {
    variables: {
      appKey,
      buildNumber: buildNumber !== null && buildNumber !== void 0 ? buildNumber : ''
    },
    skip: skip || !appKey || !buildNumber,
    errorPolicy: 'all'
  });
  const vendorLinks = {
    eula: data === null || data === void 0 ? void 0 : (_data$marketplaceStor10 = data.marketplaceStore) === null || _data$marketplaceStor10 === void 0 ? void 0 : (_data$marketplaceStor11 = _data$marketplaceStor10.appSoftwareVersionListingByAppKey) === null || _data$marketplaceStor11 === void 0 ? void 0 : (_data$marketplaceStor12 = _data$marketplaceStor11.vendorLinks) === null || _data$marketplaceStor12 === void 0 ? void 0 : _data$marketplaceStor12.eula,
    bonTermsSupported: data === null || data === void 0 ? void 0 : (_data$marketplaceStor13 = data.marketplaceStore) === null || _data$marketplaceStor13 === void 0 ? void 0 : (_data$marketplaceStor14 = _data$marketplaceStor13.appSoftwareVersionListingByAppKey) === null || _data$marketplaceStor14 === void 0 ? void 0 : (_data$marketplaceStor15 = _data$marketplaceStor14.vendorLinks) === null || _data$marketplaceStor15 === void 0 ? void 0 : _data$marketplaceStor15.bonTermsSupported,
    partnerSpecificTerms: data === null || data === void 0 ? void 0 : (_data$marketplaceStor16 = data.marketplaceStore) === null || _data$marketplaceStor16 === void 0 ? void 0 : (_data$marketplaceStor17 = _data$marketplaceStor16.appSoftwareVersionListingByAppKey) === null || _data$marketplaceStor17 === void 0 ? void 0 : (_data$marketplaceStor18 = _data$marketplaceStor17.vendorLinks) === null || _data$marketplaceStor18 === void 0 ? void 0 : _data$marketplaceStor18.partnerSpecificTerms
  };
  return {
    vendorLinks,
    data,
    error,
    loading
  };
}
const modalHeaderStyle = null;
const modalBodyStyles = null;
const printPageStyle = "\n  @page {\n    margin: 1.5cm 1cm 1cm 1.5cm;\n  }\n\n  div {\n    max-height: none;\n    overflow: visible;\n    height: auto;\n  }\n";

// Modal component for partner-specific terms
export const PartnerSpecificTermsModal = _ref => {
  let {
    isOpen,
    onClose,
    partnerSpecificTerms,
    versionInfo,
    partnerName
  } = _ref;
  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({
    contentRef,
    documentTitle: "".concat(partnerName, "-provider-specific-terms"),
    ignoreGlobalStyles: true,
    pageStyle: printPageStyle
  });
  if (!isOpen || !partnerSpecificTerms) return null;
  return /*#__PURE__*/_jsx(ModalTransition, {
    children: /*#__PURE__*/_jsxs(Modal, {
      onClose: onClose,
      children: [/*#__PURE__*/_jsxs("div", {
        ref: contentRef,
        children: [/*#__PURE__*/_jsx(ModalHeader, {
          children: /*#__PURE__*/_jsxs(CC, {
            children: [/*#__PURE__*/_jsx(CS, {
              children: [_, _2]
            }), /*#__PURE__*/_jsxs("div", {
              className: ax(["_1e0c1txw _2lx21bp4"]),
              children: [/*#__PURE__*/_jsx(ModalTitle, {
                children: "Provider-Specific Terms"
              }), versionInfo && /*#__PURE__*/_jsxs(BodyNormal, {
                children: ["App Version: ", versionInfo.version, " | Released:", ' ', DateUtils.longDate(versionInfo.releaseDate)]
              })]
            })]
          })
        }), /*#__PURE__*/_jsx(ModalBody, {
          children: /*#__PURE__*/_jsxs(CC, {
            children: [/*#__PURE__*/_jsx(CS, {
              children: [_3, _4, _5]
            }), /*#__PURE__*/_jsx("div", {
              className: ax(["_c71ltye8 _18m91wug _slp31hna"]),
              children: /*#__PURE__*/_jsx(UserGeneratedHTML, {
                dangerousHTML: partnerSpecificTerms
              })
            })]
          })
        })]
      }), /*#__PURE__*/_jsxs(ModalFooter, {
        children: [versionInfo && /*#__PURE__*/_jsx(Button, {
          iconBefore: /*#__PURE__*/_jsx(PrinterIcon, {
            label: "Print"
          }),
          onClick: handlePrint,
          children: "Print"
        }), /*#__PURE__*/_jsx(Button, {
          appearance: "primary",
          onClick: onClose,
          children: "Got it"
        })]
      })]
    })
  });
};